import { getApiGatewayClientForSession } from './self'

export async function getAuditLog(dateFrom, dateTo) {
  const apiGatewayClient = await getApiGatewayClientForSession();
  const { data } = await  apiGatewayClient.get(`/auditlog`, {}, {}, {queryParams: {from: dateFrom, to: dateTo}}, ['auditlogs']);
  return data;
}
